module.exports = __webpack_public_path__ + "img/parter-avatar10.988d2c80.png";